import { Modal } from 'antd'
import { ensureI18nInitialized } from '../../../i18n/config'
import {
  VIRTUAL_IP_STEP4_UPSTREAM_EDIT_TITLE_KEY,
  VIRTUAL_IP_UPSTREAM_EDIT_WARNING_KEY,
  virtualIpDownstreamStepLabelKeys,
  virtualIpDownstreamSteps,
} from './virtualIpProgress'

/**
 * NAVIGATION ≠ MUTATION. Only call this when the user is about to Save /
 * Confirm an upstream change that can stale downstream artifacts.
 * Never call on mere stepper click / page open.
 */
export function confirmUpstreamEditIfNeeded(options: {
  fromStep: number
  /** True when any downstream artifact already exists (confirmed profile,
   * character batches, selection, voice, …). */
  hasDownstreamArtifacts: boolean
  titleKey?: string
  onConfirm: () => void | Promise<void>
}): void {
  const i18n = ensureI18nInitialized()
  const t = i18n.getFixedT(null, 'virtualIp')
  const tActions = i18n.getFixedT(null, 'actions')

  const downstream = virtualIpDownstreamSteps(options.fromStep)
  const labelKeys = virtualIpDownstreamStepLabelKeys(options.fromStep)
  if (!options.hasDownstreamArtifacts || downstream.length === 0) {
    void options.onConfirm()
    return
  }
  const bulletList =
    labelKeys.length > 0 ? `\n\n${labelKeys.map((key) => `• ${t(key)}`).join('\n')}` : ''
  Modal.confirm({
    title: t(options.titleKey ?? VIRTUAL_IP_STEP4_UPSTREAM_EDIT_TITLE_KEY),
    content: `${t(VIRTUAL_IP_UPSTREAM_EDIT_WARNING_KEY)}${bulletList}`,
    okText: t('upstreamEdit.confirmEdit'),
    cancelText: tActions('cancel'),
    centered: true,
    onOk: () => options.onConfirm(),
  })
}
